import { DsCompanyInterface } from '../interfaces/ds-company.interface';

export class DsCompany {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public name = '';

  /**
   *
   */
  public address = '';

  /**
   *
   */
  public postalCode = '';

  /**
   *
   */
  public city = '';

  /**
   *
   */
  public site = '';

  /**
   *
   */
  public quickName = '';

  /**
   *
   */
  public siret = '';

  /**
   *
   */
  public emitter = false;

  /**
   *
   */
  public mail = '';

  /**
   *
   */
  public imputationCode = '';

  /**
   * Whether a user prevents the company from being deleted.
   */
  public cannotDeleteUser: boolean;

  /**
   * Whether a form prevents the company from being deleted.
   */
  public cannotDeleteForm: boolean;

  /**
   * Whether a pin prevents the company from being deleted.
   */
  public cannotDeletePin: boolean;

  /**
   * Whether GED prevents the company from being deleted.
   */
  public cannotDeleteGed: boolean;

  /**
   *
   */
  public isReprographic: number;

  /**
   * Lots
   */
  public lots: string[];

  /**
   * Creates an instance of DsCompany.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsCompanyInterface = {}) {
    if (jsonData) {
      this.id = jsonData.id;
      this.name = jsonData.name || this.name;
      this.address = jsonData.address || this.address;
      this.postalCode = jsonData.postalCode || this.postalCode;
      this.city = jsonData.city || this.city;
      this.site = jsonData.site || this.site;
      this.quickName = jsonData.quickName || this.quickName;
      this.siret = jsonData.siret || this.siret;
      if (jsonData.emitter) {
        this.emitter = !!jsonData.emitter;
      }
      this.cannotDeleteUser = !!jsonData.cannotDeleteUser;
      this.cannotDeleteForm = !!jsonData.cannotDeleteForm;
      this.cannotDeletePin = !!jsonData.cannotDeletePin;
      this.cannotDeleteGed = !!jsonData.cannotDeleteGed;
      this.mail = jsonData.mail || this.mail;
      this.imputationCode = jsonData.imputationCode || this.imputationCode;
      this.isReprographic = jsonData.isReprographic ? 1 : 0;
      this.lots = jsonData.lots || [];
    }
  }

  /**
   * Whether the company cannot be deleted. Returns TRUE if it cannot be deleted.
   *
   * @returns boolean
   */
  public get cannotDelete(): boolean {
    return this.cannotDeleteUser || this.cannotDeletePin || this.cannotDeleteForm || this.cannotDeleteGed;
  }
}
